import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader } from '@/components/card';
import { ClientForm } from './client-form';
import { useCreateClient } from '@/lib/clients';

export function NewClient() {
  const navigate = useNavigate();
  const create = useCreateClient();

  return (
    <div className="mx-auto max-w-3xl space-y-5">
      <h1 className="text-2xl font-semibold tracking-tight">New client</h1>
      <Card>
        <CardHeader>
          <p className="text-sm text-[var(--color-foreground-muted)]">
            Add basic details now — you can fill in contacts, documents, and projects after.
          </p>
        </CardHeader>
        <CardBody>
          <ClientForm
            showStripeOption
            onSubmit={async (input) => {
              const c = await create.mutateAsync(input);
              navigate(`/clients/${c.id}`);
            }}
            submitLabel="Create client"
          />
        </CardBody>
      </Card>
    </div>
  );
}

